const buildProfileProjectsPdfFilename = (
  locale:string,
  firstname = '',
  lastname = ''
) => {
  const localizedLabel = locale === 'en' ? 'Profile' : 'Profil';
  const nameParts = [firstname.trim(), lastname.trim()].filter(Boolean);

  return nameParts.length
    ? `ByteCookie_${localizedLabel}__${nameParts.join('_')}.pdf`
    : `ByteCookie_${localizedLabel}.pdf`;
};

export default buildProfileProjectsPdfFilename;
